import styled from 'styled-components';
import { mediaCSS } from '@web-packages/library/layouts';

export const wrapMinHeight = (minHeight) => ({
  position: 'relative',
  'min-height': `${minHeight}px`,
  width: '100%',
});

export const ImageWrapper = styled.div`
    ${({ minHeight }) => (
    minHeight && minHeight.phone
      && wrapMinHeight(minHeight.phone)
  )}
    
    ${({ minHeight }) => (
    minHeight && minHeight.tablet
      && mediaCSS.tablet(wrapMinHeight(minHeight.tablet))
  )}
    ${({ minHeight }) => (
    minHeight && minHeight.desktop
      && mediaCSS.desktop(wrapMinHeight(minHeight.desktop))
  )}
  `;
